import React, { useState, useEffect } from "react"
import { Formik, Form, Field, ErrorMessage } from "formik"
import * as Yup from "yup"
import { Col, Container, Row } from "reactstrap"
import { useDispatch } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import {
  Fn_AddEditData,
  Fn_DisplayData,
  Fn_FillListData,
} from "../../store/Functions"
import { API_WEB_URLS } from "../../constants/constAPI"
import Breadcrumbs from "../../components/Common/Breadcrumb"

function AddEdit_StoreManager() {
  const API_URL = API_WEB_URLS.MASTER + "/0/token/Godown"
  const API_URL_SAVE = "StoreManager/0/token"
  const API_URL_EDIT = API_WEB_URLS.MASTER + "/0/token/StoreManagerEdit/Id"
  const [state, setState] = useState({
    id: 0,
    FillArray: [],
    formData: {},
    OtherDataScore: [],
    isProgress: true,
  })
  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    const Id = (location.state && location.state.Id) || 0
    if (Id > 0) {
      setState(prevState => ({
        ...prevState,
        id: Id,
      }))
      Fn_DisplayData(dispatch, setState, Id, API_URL_EDIT)
    }
  }, [location.state, dispatch])

  const validationSchema = Yup.object({
    Name: Yup.string().required("Name is required"),
    Username: Yup.string().required("Username is required"),
    Password: Yup.string()
      .required("Password is required")
  })

  const handleSubmit = values => {
    const obj = JSON.parse(localStorage.getItem("YesBank"))
    const formData = new FormData()
    formData.append("Name", values.Name)
    formData.append("Username", values.Username)
    formData.append("Password", values.Password)

    Fn_AddEditData(
      dispatch,
      setState,
      { arguList: { id: state.id, formData } },
      API_URL_SAVE,
      true,
      "memberid",
      navigate,
      "/StoreManager"
    )
  }

  return (
    <div className="page-content">
      <Container boxed={true}>
        <Breadcrumbs title="Region Master" breadcrumbItem="Masters" />
        <Formik
          initialValues={state.formData}
          enableReinitialize={true}
          validationSchema={validationSchema}
          onSubmit={values => handleSubmit(values)}
        >
          <Form className="form-horizontal">
            <Row>
              <Col lg="2">
                <label htmlFor="Name" className="form-label">Name</label>
              </Col>
              <Col lg="6" className="mb-3">
                <Field className="form-control" type="text" name="Name" />
                <ErrorMessage name="Name" component="div" className="text-danger" />
              </Col>
            </Row>

            <Row>
              <Col lg="2">
                <label htmlFor="Username" className="form-label">Username</label>
              </Col>
              <Col lg="6" className="mb-3">
                <Field className="form-control" type="text" name="Username" />
                <ErrorMessage name="Username" component="div" className="text-danger" />
              </Col>
            </Row>

            <Row>
              <Col lg="2">
                <label htmlFor="Password" className="form-label">Password</label>
              </Col>
              <Col lg="6" className="mb-3">
                <Field className="form-control" type="password" name="Password" />
                <ErrorMessage name="Password" component="div" className="text-danger" />
              </Col>
            </Row>

            <button type="submit" className="btn btn-primary btn-block">
              Submit
            </button>
          </Form>
        </Formik>
      </Container>
    </div>
  )
}

export default AddEdit_StoreManager
